var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { marks, nodes as commonNodes, tableNodes } from '@progress/kendo-editor-common';
var cellAttribute = function (name) {
    var _a;
    return _a = {},
        _a[name] = {
            default: null,
            getFromDOM: function (cell) {
                return cell.getAttribute(name);
            },
            setDOMAttr: function (value, attrs) {
                attrs[name] = value;
            }
        },
        _a;
};
var getAttrs = function (node) {
    var attrs = {};
    Array.from(node.attributes).forEach(function (attr) {
        attrs[attr.nodeName] = attr.nodeValue;
    });
    return attrs;
};
var cellAttributes = __assign({}, cellAttribute('style'), cellAttribute('class'), cellAttribute('id'));
var tNodes = tableNodes({ tableGroup: 'block', cellContent: 'block+', cellAttributes: cellAttributes });
tNodes.table_row.attrs = tNodes.table_row.attrs || {};
tNodes.table_row.attrs.style = { default: null };
tNodes.table_row.attrs.class = { default: null };
tNodes.table_row.attrs.id = { default: null };
tNodes.table_row.toDOM = function (node) { return ['tr', node.attrs, 0]; };
tNodes.table_row.parseDOM = [{ tag: 'tr', getAttrs: getAttrs }];
tNodes.table.attrs = tNodes.table.attrs || {};
tNodes.table.attrs.style = { default: null };
tNodes.table.attrs.class = { default: null };
tNodes.table.attrs.id = { default: null };
tNodes.table.toDOM = function (node) {
    return ['table', node.attrs, ['tbody', 0]];
};
tNodes.table.parseDOM = [{ tag: 'table', getAttrs: getAttrs }];
var nodes = __assign({}, commonNodes, tNodes);
export { marks, nodes };
